// AUTO-GENERATED SQL Builder (V40 Final) for BookingCancellation
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingCancellationSql {
  private ast = new SqlAst('BookingCancellation', 'bookingCancellation');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingId: SqlField;
  public cancelledBy: SqlField;
  public reason: SqlField;
  public stageAtCancel: SqlField;
  public heldAtCancel: SqlField;
  public refundAmount: SqlField;
  public vendorKeepAmount: SqlField;
  public forfeitAmount: SqlField;
  public forfeitDestination: SqlField;
  public feeRefundAmount: SqlField;
  public feeKeptAmount: SqlField;
  public advanceOutstanding: SqlField;
  public clawbackAmount: SqlField;
  public fundOwedAmount: SqlField;
  public fundCoverAmount: SqlField;
  public cancelledDate: SqlField;
  public booking: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingCancellation', 'guid', '', 'id', 'bookingCancellation_guid');
    this.bookingId = new SqlField('bookingCancellation', 'bookingId', 'booking', 'id', 'bookingCancellation_booking');
    this.cancelledBy = new SqlField('bookingCancellation', 'cancelledBy', '', 'id', 'bookingCancellation_cancelledBy');
    this.reason = new SqlField('bookingCancellation', 'reason', '', 'id', 'bookingCancellation_reason');
    this.stageAtCancel = new SqlField('bookingCancellation', 'stageAtCancel', '', 'id', 'bookingCancellation_stageAtCancel');
    this.heldAtCancel = new SqlField('bookingCancellation', 'heldAtCancel', '', 'id', 'bookingCancellation_heldAtCancel');
    this.refundAmount = new SqlField('bookingCancellation', 'refundAmount', '', 'id', 'bookingCancellation_refundAmount');
    this.vendorKeepAmount = new SqlField('bookingCancellation', 'vendorKeepAmount', '', 'id', 'bookingCancellation_vendorKeepAmount');
    this.forfeitAmount = new SqlField('bookingCancellation', 'forfeitAmount', '', 'id', 'bookingCancellation_forfeitAmount');
    this.forfeitDestination = new SqlField('bookingCancellation', 'forfeitDestination', '', 'id', 'bookingCancellation_forfeitDestination');
    this.feeRefundAmount = new SqlField('bookingCancellation', 'feeRefundAmount', '', 'id', 'bookingCancellation_feeRefundAmount');
    this.feeKeptAmount = new SqlField('bookingCancellation', 'feeKeptAmount', '', 'id', 'bookingCancellation_feeKeptAmount');
    this.advanceOutstanding = new SqlField('bookingCancellation', 'advanceOutstanding', '', 'id', 'bookingCancellation_advanceOutstanding');
    this.clawbackAmount = new SqlField('bookingCancellation', 'clawbackAmount', '', 'id', 'bookingCancellation_clawbackAmount');
    this.fundOwedAmount = new SqlField('bookingCancellation', 'fundOwedAmount', '', 'id', 'bookingCancellation_fundOwedAmount');
    this.fundCoverAmount = new SqlField('bookingCancellation', 'fundCoverAmount', '', 'id', 'bookingCancellation_fundCoverAmount');
    this.cancelledDate = new SqlField('bookingCancellation', 'cancelledDate', '', 'id', 'bookingCancellation_cancelledDate');
    this.booking = createNavHybrid('bookingCancellation', 'bookingCancellation_booking', 'Booking');
    this.createdByUser = createNavHybrid('bookingCancellation', 'bookingCancellation_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('bookingCancellation', 'bookingCancellation_updatedByUser', 'User');
    this.id = new SqlField('bookingCancellation', 'id', '', 'id', 'bookingCancellation_id');
    this.isDeleted = new SqlField('bookingCancellation', 'isDeleted', '', 'id', 'bookingCancellation_isDeleted');
    this.createdBy = new SqlField('bookingCancellation', 'createdBy', '', 'id', 'bookingCancellation_createdBy');
    this.createdDate = new SqlField('bookingCancellation', 'createdDate', '', 'id', 'bookingCancellation_createdDate');
    this.updatedBy = new SqlField('bookingCancellation', 'updatedBy', '', 'id', 'bookingCancellation_updatedBy');
    this.updatedDate = new SqlField('bookingCancellation', 'updatedDate', '', 'id', 'bookingCancellation_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingCancellationSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingCancellationSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingCancellationSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingCancellationSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingCancellationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingCancellationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingCancellationSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingCancellationSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingCancellationSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingCancellationSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
